import React, { useEffect, useMemo, useState } from 'react';
import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import { Stack } from '@mui/system';
import { jsonPathToValue } from '../../utils/json';
import { META_DATA_MODULES, META_DATA_SUB_MODULES } from '../../utils/constants';
import { getVehicleConfiguration } from '../../services/vehicles';
import Typography from '../../components/Typography/Typography';
import FieldList from './FieldList';
import TabLoader from './TabLoader';
import useMetaData from '../../hooks/useMetaData';

const Vehicle = () => {
  const { reservationId } = useParams<{ reservationId: string }>();
  const [data, setData] = useState<any>();
  const metaData = useMetaData(META_DATA_MODULES.v360Page, META_DATA_SUB_MODULES.vehicleTab);

  useEffect(() => {
    if (reservationId) {
      getVehicleConfiguration(reservationId).then((response) => setData(response));
    }
  }, [reservationId]);

  const vehicleFields = useMemo(
    () =>
      data
        ? metaData?.rows?.map((row: any) => {
            const value = jsonPathToValue(data, row.property);
            const isVIN = row.propertyName === 'VIN';

            if (isVIN) {
              return {
                field: row.propertyName,
                value: value || 'Not Assigned',
              };
            }

            return {
              field: row?.propertyName,
              value: row.type === 'Date' && value ? moment(value).format('MMM D, YYYY') : value,
            };
          })
        : [],
    [data, metaData?.rows]
  );

  if (!metaData || !data) {
    return <TabLoader />;
  }

  return (
    <Box width="100%">
      <Stack direction="row" alignItems="center" justifyContent="space-between" pt={2.5} pr={1.5} pl={1.5} pb={1}>
        <Typography size={12} weight={500} uppercase>
          Vehicle Details & Configuration
        </Typography>
        <Typography size={12} weight={500} color="primary.main" sx={{ cursor: 'pointer' }}>
          View Changes
        </Typography>
      </Stack>
      <FieldList fields={vehicleFields} />
      <Stack direction="row" alignItems="center" justifyContent="space-between" pt={3.2} pr={1.5} pl={1.5} pb={0.9}>
        <Typography size={12} weight={500} uppercase>
          Charging Package
        </Typography>
      </Stack>
      <FieldList fields={vehicleFields} />
      <Stack direction="row" alignItems="center" justifyContent="space-between" pt={3.2} pr={1.5} pl={1.5} pb={0.9}>
        <Typography size={12} weight={500} uppercase>
          Charging Plan
        </Typography>
      </Stack>
      <FieldList fields={vehicleFields} />
    </Box>
  );
};

export default Vehicle;
